import {IRange} from "@pg-design/inputs-module";
import {isNumber} from "@pg-mono/nodash";

/**
 * Checkbox range options have special case for rendering ranges. They are displayed (view-data) as an array of numbers (options count), but used as a range (api-data).
 * view-data: [1, 2, 3, 4, 5]
 * api-data: {lower: 1, upper: 5}
 *
 * (i) range [1..5] equals range [], because all checkbox range options are selected, so no option fits that fine
 * (i) 5 means 5+ so upper bound is opened in this case
 */

type IRangeCheckboxType = IRange<number | "">;

const getValidLower = (lower: IRangeCheckboxType["lower"], min: number) => Math.max(lower || min, min);
const getValidUpper = (upper: IRangeCheckboxType["upper"], max: number) => Math.min(upper || max, max);
const validateBound = (value: IRangeCheckboxType, filterOptionValueMin: number, filterOptionValueMax: number): IRangeCheckboxType => {
    const {lower, upper} = value;
    // open bounds
    if (!Number.isFinite(lower) && !Number.isFinite(upper)) {
        // undefined bounds
        return value;
    }
    if (!Number.isFinite(lower) && isNumber(upper, true)) {
        // no left bound
        return upper < filterOptionValueMin
            ? {lower: "", upper: ""} // invalid upper bound
            : upper < filterOptionValueMax
              ? value
              : {lower: filterOptionValueMin, upper: filterOptionValueMax};
    }
    if (!Number.isFinite(upper) && isNumber(lower, true)) {
        // no right bound
        return lower > filterOptionValueMax
            ? {lower: "", upper: ""} // invalid lower bound
            : lower > filterOptionValueMin
              ? value
              : {lower: filterOptionValueMin, upper: filterOptionValueMax};
    }
    // defined bounds
    if (isNumber(upper, true) && isNumber(lower, true)) {
        if (upper < lower) {
            // error bound
            return {lower: "", upper: ""};
        }
        if (lower <= filterOptionValueMin && upper >= filterOptionValueMax) {
            // border bounds
            return {lower: filterOptionValueMin, upper: filterOptionValueMax};
        }
        if (lower <= filterOptionValueMin) {
            // border left bound
            return {lower: "", upper};
        }
        if (upper >= filterOptionValueMax) {
            // border right bound
            return {lower, upper: ""};
        }
    }

    return value;
};

export const isValueInRange = (
    value: IRangeCheckboxType,
    filterOptionValue: number,
    filterOptionValueMin: number,
    filterOptionValueMax: number,
    threshold = 0
) => {
    const {lower, upper} = value;
    if (!lower && !upper) {
        return false;
    }
    const validLower = getValidLower(lower, filterOptionValueMin);
    const validUpper = getValidUpper(upper, filterOptionValueMax);
    return validLower - threshold <= filterOptionValue && filterOptionValue <= validUpper + threshold;
};

export const updateValueBounds = (
    value: IRangeCheckboxType,
    filterOptionValue: number,
    filterOptionValueMin: number,
    filterOptionValueMax: number,
    availableOptionValues: number[]
) => {
    return validateBound(
        updateValueBoundsNotValidated(value, filterOptionValue, filterOptionValueMin, filterOptionValueMax),
        filterOptionValueMin,
        filterOptionValueMax
    );

    // helper function
    function updateValueBoundsNotValidated(
        value: IRangeCheckboxType,
        filterOptionValue: number,
        filterOptionValueMin: number,
        filterOptionValueMax: number
    ): IRangeCheckboxType {
        const {lower, upper} = value;
        if (!lower && !upper) {
            return {lower: filterOptionValue, upper: filterOptionValue};
        }
        const validLower = getValidLower(lower, filterOptionValueMin);
        const validUpper = getValidUpper(upper, filterOptionValueMax);
        if (isValueInRange(value, filterOptionValue, filterOptionValueMin, filterOptionValueMax)) {
            // cut the range
            const leftDistance = Math.abs(filterOptionValue - validLower);
            const rightDistance = Math.abs(filterOptionValue - validUpper);
            // cut (left or right) values up to the `option` point
            const isLeftDistanceLower = leftDistance < rightDistance;
            const newLower = isLeftDistanceLower
                ? getNextAvailableBound(filterOptionValue, filterOptionValueMin, filterOptionValueMax, 1, availableOptionValues)
                : lower;
            const newUpper = isLeftDistanceLower
                ? upper
                : getNextAvailableBound(filterOptionValue, filterOptionValueMin, filterOptionValueMax, -1, availableOptionValues);

            return isLeftDistanceLower ? {lower: newLower, upper} : {lower, upper: newUpper};
        } else {
            // expand the range => left or right
            return filterOptionValue < validLower ? {lower: filterOptionValue, upper} : {lower, upper: filterOptionValue};
        }
    }
};

const getNextAvailableBound = (
    filterOptionValue: number,
    filterOptionValueMin: number,
    filterOptionValueMax: number,
    diff: number,
    availableOptionValues: number[]
): number => {
    const newOption = filterOptionValue + diff;
    if (newOption < filterOptionValueMin || newOption > filterOptionValueMax) {
        return 0;
    }

    const isNewOptionAvailable = availableOptionValues.some((option: number) => option === newOption);
    if (isNewOptionAvailable) {
        return newOption;
    }

    // if out of range set 0
    if (newOption < filterOptionValueMin || newOption > filterOptionValueMax) {
        return 0;
    }

    switch (newOption) {
        case filterOptionValueMin:
            return filterOptionValueMin;
        case filterOptionValueMax:
            return filterOptionValueMax;
        default:
            return getNextAvailableBound(newOption, filterOptionValueMin, filterOptionValueMax, diff, availableOptionValues);
    }
};
import {IRange} from "@pg-design/inputs-module";
import {isNumber} from "@pg-mono/nodash";

/**
 * Checkbox range options have special case for rendering ranges. They are displayed (view-data) as an array of numbers (options count), but used as a range (api-data).
 * view-data: [1, 2, 3, 4, 5]
 * api-data: {lower: 1, upper: 5}
 *
 * (i) range [1..5] equals range [], because all checkbox range options are selected, so no option fits that fine
 * (i) 5 means 5+ so upper bound is opened in this case
 */

type IRangeCheckboxType = IRange<number | "">;

const getValidLower = (lower: IRangeCheckboxType["lower"], min: number) => Math.max(lower || min, min);
const getValidUpper = (upper: IRangeCheckboxType["upper"], max: number) => Math.min(upper || max, max);
const validateBound = (value: IRangeCheckboxType, filterOptionValueMin: number, filterOptionValueMax: number): IRangeCheckboxType => {
    const {lower, upper} = value;
    // open bounds
    if (!Number.isFinite(lower) && !Number.isFinite(upper)) {
        // undefined bounds
        return value;
    }
    if (!Number.isFinite(lower) && isNumber(upper, true)) {
        // no left bound
        return upper < filterOptionValueMin
            ? {lower: "", upper: ""} // invalid upper bound
            : upper < filterOptionValueMax
              ? value
              : {lower: filterOptionValueMin, upper: filterOptionValueMax};
    }
    if (!Number.isFinite(upper) && isNumber(lower, true)) {
        // no right bound
        return lower > filterOptionValueMax
            ? {lower: "", upper: ""} // invalid lower bound
            : lower > filterOptionValueMin
              ? value
              : {lower: filterOptionValueMin, upper: filterOptionValueMax};
    }
    // defined bounds
    if (isNumber(upper, true) && isNumber(lower, true)) {
        if (upper < lower) {
            // error bound
            return {lower: "", upper: ""};
        }
        if (lower <= filterOptionValueMin && upper >= filterOptionValueMax) {
            // border bounds
            return {lower: filterOptionValueMin, upper: filterOptionValueMax};
        }
        if (lower <= filterOptionValueMin) {
            // border left bound
            return {lower: "", upper};
        }
        if (upper >= filterOptionValueMax) {
            // border right bound
            return {lower, upper: ""};
        }
    }

    return value;
};

export const isValueInRange = (
    value: IRangeCheckboxType,
    filterOptionValue: number,
    filterOptionValueMin: number,
    filterOptionValueMax: number,
    threshold = 0
) => {
    const {lower, upper} = value;
    if (!lower && !upper) {
        return false;
    }
    const validLower = getValidLower(lower, filterOptionValueMin);
    const validUpper = getValidUpper(upper, filterOptionValueMax);
    return validLower - threshold <= filterOptionValue && filterOptionValue <= validUpper + threshold;
};

export const updateValueBounds = (
    value: IRangeCheckboxType,
    filterOptionValue: number,
    filterOptionValueMin: number,
    filterOptionValueMax: number,
    availableOptionValues: number[]
) => {
    return validateBound(
        updateValueBoundsNotValidated(value, filterOptionValue, filterOptionValueMin, filterOptionValueMax),
        filterOptionValueMin,
        filterOptionValueMax
    );

    // helper function
    function updateValueBoundsNotValidated(
        value: IRangeCheckboxType,
        filterOptionValue: number,
        filterOptionValueMin: number,
        filterOptionValueMax: number
    ): IRangeCheckboxType {
        const {lower, upper} = value;
        if (!lower && !upper) {
            return {lower: filterOptionValue, upper: filterOptionValue};
        }
        const validLower = getValidLower(lower, filterOptionValueMin);
        const validUpper = getValidUpper(upper, filterOptionValueMax);
        if (isValueInRange(value, filterOptionValue, filterOptionValueMin, filterOptionValueMax)) {
            // cut the range
            const leftDistance = Math.abs(filterOptionValue - validLower);
            const rightDistance = Math.abs(filterOptionValue - validUpper);
            // cut (left or right) values up to the `option` point
            const isLeftDistanceLower = leftDistance < rightDistance;
            const newLower = isLeftDistanceLower
                ? getNextAvailableBound(filterOptionValue, filterOptionValueMin, filterOptionValueMax, 1, availableOptionValues)
                : lower;
            const newUpper = isLeftDistanceLower
                ? upper
                : getNextAvailableBound(filterOptionValue, filterOptionValueMin, filterOptionValueMax, -1, availableOptionValues);

            return isLeftDistanceLower ? {lower: newLower, upper} : {lower, upper: newUpper};
        } else {
            // expand the range => left or right
            return filterOptionValue < validLower ? {lower: filterOptionValue, upper} : {lower, upper: filterOptionValue};
        }
    }
};

const getNextAvailableBound = (
    filterOptionValue: number,
    filterOptionValueMin: number,
    filterOptionValueMax: number,
    diff: number,
    availableOptionValues: number[]
): number => {
    const newOption = filterOptionValue + diff;
    if (newOption < filterOptionValueMin || newOption > filterOptionValueMax) {
        return 0;
    }

    const isNewOptionAvailable = availableOptionValues.some((option: number) => option === newOption);
    if (isNewOptionAvailable) {
        return newOption;
    }

    // if out of range set 0
    if (newOption < filterOptionValueMin || newOption > filterOptionValueMax) {
        return 0;
    }

    switch (newOption) {
        case filterOptionValueMin:
            return filterOptionValueMin;
        case filterOptionValueMax:
            return filterOptionValueMax;
        default:
            return getNextAvailableBound(newOption, filterOptionValueMin, filterOptionValueMax, diff, availableOptionValues);
    }
};
